/**
 * IconButtonFab — Fully assembled IconButton.
 *
 * Pass icon, variant, size — color resolved internally.
 * For full control, use the primitive IconButton instead.
 */
import type { LucideIcon } from 'lucide-react-native'
import type { GetProps } from 'tamagui'
import { IconButton, ICON_BUTTON_COLOR } from '../elements/IconButton'

const ICON_SIZE: Record<string, number> = {
  sm: 16,
  md: 20,
  lg: 24,
}

type IconButtonFrameProps = GetProps<typeof IconButton>

interface IconButtonFabProps extends Omit<IconButtonFrameProps, 'children'> {
  icon: LucideIcon
}

export function IconButtonFab({
  icon: Icon,
  variant = 'default',
  size = 'md',
  ...props
}: IconButtonFabProps) {
  const iconColor = ICON_BUTTON_COLOR[variant] ?? '$color'
  const iconSize = ICON_SIZE[size] ?? 20

  return (
    <IconButton variant={variant} size={size} {...props}>
      <Icon size={iconSize} color={iconColor} />
    </IconButton>
  )
}
